import { useInfiniteQuery } from 'react-query';
import { PortoTasksListRequest } from './porto-tasks.types';
import portoTasksServices from './porto-tasks.services';
import notificationError from '@/utils/functions/notificationError';
import { isAppPortocar } from '@/index';

const QUERY_PORTO_TASK_LIST = 'operationa/porto-task/list';

export function usePortoTaskList(params?: PortoTasksListRequest) {
  return useInfiniteQuery({
    queryKey: [QUERY_PORTO_TASK_LIST, params],
    queryFn: ({ pageParam }) =>
      portoTasksServices.list({ ...params, nextToken: pageParam }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled: isAppPortocar,
    onError(error) {
      notificationError(error);
    },
  });
}
